// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__28NNx","dragIcon":"Choice_dragIcon__AcY1v","left":"Choice_left__2Cn2T","input":"Choice_input__2059e"};